import type { CanMatchFn } from '@angular/router';

import { PRODUCT_KINDS } from '@app/product-support/product-support.type';

const SUPPORTED_CATEGORIES = Object.values(PRODUCT_KINDS) as string[];

export const productSupportCategoryGuard: CanMatchFn = (route, segments) => {
  const category = segments[0]?.path ?? '';
  return SUPPORTED_CATEGORIES.includes(category);
};
